import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Component from "vue-class-component";
Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate"
]);


import Home from '@/views/Home.vue'
import Blog from '@/views/Blog.vue'
import Contact from '@/views/Contact.vue'
import About from '@/views/About.vue'
import Works from '@/views/Works.vue'
import Nav from '@/components/Nav.vue'

import {getAnalytics} from '@/services/FireBaseAnalytics';



Vue.use(VueRouter)

const routes: any = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About
  },
  {
    path: '/works',
    name: 'Works',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Works
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/contact',
    name: 'Contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Contact
  }
]

const router = new VueRouter({
  routes
})

router.afterEach( ( to: any, from: any ) => {
  //console.log( "View: " + to.name );
  getAnalytics().logEvent('event', 'screen_view', {
    'screen_name': to.name,
  });

});

export default router
